import { System } from '@ecs/System';
import { Energy } from '@components/Energy';
import { Tag } from '@components/Tag';

export class EnergyUISystem extends System {
  update(_deltaTime: number): void {
    const players = this.getEntitiesWithComponents(Energy, Tag);

    for (const player of players) {
      const tag = player.getComponent(Tag)!;
      if (tag.value !== 'player') continue;

      const energy = player.getComponent(Energy)!;
      const energyElement = document.getElementById('energy');
      if (energyElement) {
        energyElement.textContent = Math.floor(energy.current).toString();
      }
    }
  }
}